import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useState } from 'react'
import { api, setToken } from '@/lib/api'
import { useAuthStore } from '@/store/auth'

export const Route = createFileRoute('/login')({
  component: LoginPage,
})

function LoginPage() {
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const setAuthenticated = useAuthStore((s) => s.setAuthenticated)
  const navigate = useNavigate()

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    try {
      const res = await api.login(password)
      setToken(res.token)
      setAuthenticated(true)
      navigate({ to: '/' })
    } catch {
      setError('Invalid password')
    }
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <form onSubmit={handleLogin} className="card" style={{ width: 360, display: 'flex', flexDirection: 'column', gap: 16 }}>
        <h2 style={{ textAlign: 'center', color: 'var(--accent)' }}>Proxima Indexer</h2>
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoFocus
        />
        {error && <div style={{ color: 'var(--red)', fontSize: 13 }}>{error}</div>}
        <button type="submit" className="btn btn-primary">Login</button>
      </form>
    </div>
  )
}
